export default () => ({
	active_tab: 'info',
	show_menu_mobile: false,
	edit_address: false,
	current_form: '',
	delete_form: null,
	show_delete: false,
	order_quantity: 5,

	changeTab(tabName, close) {
		if (tabName === 'info') {
			this.active_tab = 'info';
			window.location.href = window.location.pathname + '#info';
		}

		if (tabName === 'orders') {
			this.active_tab = 'orders';
			window.location.href = window.location.pathname + '#edit-orders';
		}
		if (tabName === 'edit-address') {
			this.active_tab = 'edit-address';
			window.location.href = window.location.pathname + '#edit-address';
		}

		if (tabName === 'login') {
			this.active_tab = 'login';
			window.location.href = window.location.pathname + '#login';
		}

		if (tabName === 'recover') {
			this.active_tab = 'recover';
			window.location.href = window.location.pathname + '#recover';
		}

		if (close === true) {
			this.show_menu_mobile = false;
		}
	},

	editAddress(address) {
		if (address === 'default') {
			this.current_form = 'default';
		} else if (address === 'new') {
			this.current_form = 'new';
		} else {
			let form = `address-form-${address}`;
			this.current_form = form;
		}
		this.active_tab = 'edit-address';
		window.location.href = window.location.pathname + '#edit-address';
		this.edit_address = true;
	},

	showPopup(id) {
		const form = document.querySelector(`.address-delete-form-${id}`);
		this.delete_form = form;
		this.show_delete = true;
	},

	closeConfirm() {
		this.delete_form = null;
		this.show_delete = false;
	},

	deleteAddress() {
		if (this.delete_form) {
			this.delete_form.submit();
		}
	},

	setAddressUrl() {
		window.location.href = window.location.pathname;
	},

	watchUrl() {
		if (window.location.href.includes('edit-orders')) {
			this.active_tab = 'orders';
		}

		if (window.location.href.includes('info')) {
			this.active_tab = 'info';
		}
		if (window.location.href.includes('edit-address')) {
			this.active_tab = 'edit-address';
		}

		if (window.location.href.includes('recover')) {
			this.active_tab = 'recover';
		}
	},

	setPreselectCountry() {
		const select = document.querySelectorAll('[data-address-country-select]');
		select.forEach((el) => {
			const formId = el.dataset.formId;
			// eslint-disable-next-line no-new
			new Shopify.CountryProvinceSelector(`AddressCountry_${formId}`, `AddressProvince_${formId}`, {
				hideElement: `AddressProvinceContainer_${formId}`,
			});
		});
	},

	showMore() {
		this.order_quantity += 5;
	},

	copyToClipboard(number) {
		navigator.clipboard.writeText(number);
		const message = this.$el.nextElementSibling;
		message.style.display = 'block';
		setTimeout(() => {
			message.style.display = 'none';
		}, 2000);
	},
	init() {
		this.setPreselectCountry();
		this.watchUrl();
		window.addEventListener('popstate', () => {
			this.watchUrl();
		});
	},
});
